import { render, staticRenderFns } from "./SetStaticWebsit.vue?vue&type=template&id=4a9da3c6"
import script from "./SetStaticWebsit.vue?vue&type=script&lang=js"
export * from "./SetStaticWebsit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports